/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamCsvImportSubmitRequestSchema = z.object({
  configS3Key: z.string().min(1),
  itemsS3Key: z.string().min(1),
});
